(function () {
    const WIDGET_SELECTOR =
        '.sealsubs-container, .sealsubs-dropdown-wrapper, .sealsubs-target-element';
    const PLAN_INPUT_SELECTOR =
        'form[action*="/cart/add"] input[name="selling_plan"]';

    let scheduled = false;

    function strip() {
        scheduled = false;
        document.querySelectorAll(WIDGET_SELECTOR).forEach(function (el) {
            el.remove();
        });
        document.querySelectorAll(PLAN_INPUT_SELECTOR).forEach(function (el) {
            el.remove();
        });
    }

    function schedule() {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(strip);
    }

    strip();
    new MutationObserver(schedule).observe(document.documentElement, {
        childList: true,
        subtree: true,
    });
    document.addEventListener('DOMContentLoaded', strip);
    window.addEventListener('load', strip);
})();
